import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Header,
  Modal,
} from 'semantic-ui-react';
import ProjectUnitsList from '../../components/ProjectUnitsList';

export default class UnitsList extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    projectID: PropTypes.string,
    unitLayout: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    where: PropTypes.shape({
      limit: PropTypes.number,
      projectUnitLayoutID: PropTypes.string,
    }),
    project: PropTypes.shape({
      siteplanSettings: PropTypes.shape({
        salesChartSimpleMode: PropTypes.bool,
        unitListDisableClickUnavailable: PropTypes.bool,
      }),
      activeBookingsInUnits: PropTypes.bool,
    }),
  }
  handleBook = (e, { unit }) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, { unit });
    }
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  render() {
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
      >
        <Header
          icon="home"
          content={`${this.props.unitLayout ? this.props.unitLayout.name : 'Book'} units`}
        />
        <Modal.Content>
          <ProjectUnitsList
            toggleable
            projectID={this.props.projectID}
            project={this.props.project}
            unitLayoutID={this.props.unitLayout ? this.props.unitLayout.id : null}
            where={this.props.where}
            unitOnClick={this.handleBook}
          />
        </Modal.Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/UnitsList.jsx